module.exports = __webpack_public_path__ + "static/media/1.031e6426.svg";